import React from 'react'
import { LoginForm } from '../auth/LoginForm'

/** Uses the complete existing password/MFA flow. No presenter credential exchange. */
export const DemoAccountSignIn: React.FC = () => {
  const account=new URLSearchParams(window.location.search).get('account')||''
  const email=/^[a-z][a-z0-9]{1,63}@test\.com$/.test(account)?account:''
  return <main className="mx-auto max-w-lg space-y-4 p-6">
    <h1 className="text-2xl font-semibold">Demonstration account sign-in / Connexion au compte</h1>
    <p>Enter the selected account’s credentials. Any required MFA remains mandatory. / Saisissez les identifiants du compte et complétez la vérification MFA requise.</p>
    <LoginForm initialEmail={email} onSuccess={()=>window.location.assign('/admin')}/>
    <a href="/demo-showcase">Return to showcase / Retour à la démonstration</a>
  </main>
}
